/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClientContactMappingItem = {
    /**
     * Client ID to map
     */
    clientId: number;
    /**
     * External contact ID from the accounting provider
     */
    externalContactId: string;
    /**
     * How the mapping was created
     */
    mappingType?: ClientContactMappingItem.mappingType;
};
export namespace ClientContactMappingItem {
    /**
     * How the mapping was created
     */
    export enum mappingType {
        MANUAL = 'manual',
        AUTO = 'auto',
        SUGGESTED = 'suggested',
    }
}

